import { FormControl, InputAdornment, TextField } from "@material-ui/core"
import React, { useLayoutEffect, useState } from "react"

import { IconSearch, IconX } from "../../../utils/IconsList"

import MultiSelect from "./MultiSelect"

const DisplayFilters = ({
  jobs,
  jobsByDept,
  currentJobs,
  setCurrentJobs,
  departments,
  countries,
  filters,
  setFilters,
}) => {
  const [hasFilters, setHasFilters] = useState(false)
  const [searchField, setSearchField] = useState("")
  const [currentValue, setCurrentValue] = useState([])

  useLayoutEffect(() => {
    if (!hasFilters) {
      setCurrentJobs(jobsByDept)
    }
  }, [hasFilters, currentJobs])

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value })
  }

  const handleSearch = (e) => {
    handleChange(e)
    setSearchField(e.target.value)
  }

  const handleClearAll = () => {
    setFilters({
      selectedDepartments: [],
      selectedCountries: [],
      searchField: "",
    })
    setSearchField("")
    setCurrentValue([])
  }

  useLayoutEffect(() => {
    if (
      filters?.selectedDepartments?.length > 0 ||
      filters?.selectedCountries?.length > 0 ||
      filters?.searchField?.length > 0
    ) {
      setHasFilters(true)
    } else {
      setHasFilters(false)
    }
    if (!hasFilters) {
      setCurrentJobs(jobsByDept)
    }
  }, [filters])
  const handleFilters = () => {
    const filteredJobs = hasFilters
      ? jobs.filter((job) => {
          const locationFilter =
            filters?.selectedCountries?.length > 0
              ? filters?.selectedCountries?.includes(job?.country)
              : true
          const deptFilter =
            filters?.selectedDepartments?.length > 0
              ? filters?.selectedDepartments?.includes(job?.department)
              : true

          const searchJobs = job?.title
            .toLowerCase()
            .includes(filters?.searchField?.toLowerCase())
          return locationFilter && deptFilter && searchJobs
        })
      : []

    const filteredJobsByDept = filteredJobs?.reduce((deptsWithJobs, job) => {
      const department = job?.department
      if (deptsWithJobs[department] == null) {
        deptsWithJobs[department] = []
      }
      deptsWithJobs[department].push(job)
      return deptsWithJobs
    }, {})
    setCurrentJobs(filteredJobsByDept)
  }

  useLayoutEffect(() => {
    handleFilters()
  }, [filters, hasFilters])

  return (
    <div>
      <MultiSelect
        items={departments}
        placeholder="departments"
        name="selectedDepartments"
        onChange={(e) => handleChange(e)}
        value={filters?.selectedDepartments}
        currentValue={currentValue}
        setCurrentValue={setCurrentValue}
      />
      <MultiSelect
        items={countries}
        placeholder="countries"
        name="selectedCountries"
        onChange={(e) => handleChange(e)}
        value={filters?.selectedCountries}
        currentValue={currentValue}
        setCurrentValue={setCurrentValue}
      />
      <FormControl fullWidth>
        <TextField
          placeholder="Search"
          name="searchField"
          onChange={(e) => handleSearch(e)}
          value={searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconSearch className="search" />
              </InputAdornment>
            ),
            shrink: false,
          }}
        />
      </FormControl>
      {hasFilters ? (
        <button className="clear-all" onClick={handleClearAll}>
          Clear all filters <IconX />
        </button>
      ) : null}
    </div>
  )
}

export default DisplayFilters
